import React, { createContext, useContext, useState } from "react";

const ControllerTokenContext = createContext();

export const ControllerTokenProvider = ({ children }) => {
  const [controllerToken, setControllerToken] = useState(null);

  const updateControllerToken = (newControllerToken) => {
    setControllerToken(newControllerToken);
    if (newControllerToken) {
      localStorage.setItem("controllerToken", newControllerToken);
    } else {
      localStorage.removeItem("controllerToken");
    }
  };

  return (
    <ControllerTokenContext.Provider value={{ controllerToken, updateControllerToken }}>
      {children}
    </ControllerTokenContext.Provider>
  );
};

export const useControllerToken = () => useContext(ControllerTokenContext);
